import { useCallback } from "react";
import { useHistory } from "react-router";
import useUserInfo from "./useUserInfo";
import useLocalStorage from "./useLocalStorage";
import { URL } from "../constant";
import { mathpidLogAPICall } from "../redux/logData";
import { useDispatch } from "react-redux";
import { openOcr, setBackPressedOcr } from "../utils/utilityEtc";
import useAmplitude from "./useAmplitude";


export default function useAppOcrOnOff() {
  const history = useHistory();
  const logDispatch = useDispatch();
  const { info } = useUserInfo();
  const { userData, setUserData } = useLocalStorage();
  const { setAmplitudeLog } = useAmplitude();

  const appOcrOnOff = useCallback((yn) => {

  if (yn === 'Y') setBackPressedOcr(info.learnerId);
  else setBackPressedOcr('');

  }, [info]);

  const handleOcr = useCallback(() => {
    const p = userData.ocrUsage;
    
    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0002_0000',
    }));

    setAmplitudeLog({ eventCategory: 'app_usage', eventName: 'ocr학습메인 조회', isHackleSend: true, });
    
    if (p === 'Y') {
      const { learnerId } = info;
      openOcr(learnerId);
      // history.push({pathname: URL.OCR.HISTORY});
      // history.push({
      //   pathname: URL.OCR.RECOMMEND_LEARNING,
      //   state: { 
      //     average: "99.9",
      //     data: ['B02_0_2'],
      //     fulls3path: "https://wjtb-dev-brs-ocr.s3.ap-northeast-2.amazonaws.com/202111/LRN20211126170000722/ca375340-57c5-11ec-92dd-77245bb41bf8.JPG",
      //     latex: "XCggMysyPSBcKQ==",
      //     page: "/rcmndlearning",
      //   }
      // });
    } else {
      history.push({ pathname: URL.OCR.USAGE });
      setUserData({ ocrUsage: 'Y' });
    }
  }, [info, userData]);

  return { appOcrOnOff, handleOcr };
}
